import CardProduct from "@components/global/card-product/card-product"
import { useScrollAnim } from "@components/hooks/hooks"

export default function ProjectGalleryDetailProducts({ list }) {
  const [trigger, anim] = useScrollAnim()

  return (
    <section
      className="sc-project-gallery-detail-products py-main container"
      ref={trigger}
    >
      <h2 className={`title-section mb-3 ${anim(1)}`}>Featured Products</h2>
      <div className="row">
        {list?.map((item, index) => (
          <RenderProductCard item={item} index={index} key={index} />
        ))}
      </div>
    </section>
  )
}

function RenderProductCard({ item, index }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <div className={`col-6 col-md-3 mb-4`} ref={trigger} key={index}>
      <CardProduct {...item} className={anim(index)} />
    </div>
  )
}
